import './auth.css';
import { mountTemplate } from './modal-base';
import { t } from '../../i18n';
import { mountLangSwitcher } from '../lang-switcher';

function buildAuthTemplate(): string {
  return /* html */ `
<div class="modal-overlay" id="auth-modal">
  <div class="modal-content">
    <h3 id="auth-title" style="margin-top:0;">${t('auth.login')}</h3>
    <p class="auth-note">${t('auth.note')}</p>
    <div class="auth-tabs" id="auth-tabs">
      <button type="button" id="auth-tab-login" class="auth-tab active" onclick="switchAuthMode('login')">${t('auth.loginTab')}</button>
      <button type="button" id="auth-tab-register" class="auth-tab" onclick="switchAuthMode('register')">${t('auth.register')}</button>
    </div>
    <form onsubmit="submitAuthForm(event)">
      <div id="auth-email-wrap">
        <input type="email" id="auth-email" placeholder="${t('auth.email')}" autocomplete="email" required>
      </div>
      <div id="auth-otp-wrap" style="display:none;">
        <p class="auth-note" id="auth-otp-note"></p>
        <input type="text" id="auth-otp" class="auth-otp-input" placeholder="${t('auth.otpPlaceholder')}" aria-label="${t('auth.otpPlaceholder')}" inputmode="numeric" autocomplete="one-time-code" pattern="[0-9]{6}" maxlength="6">
      </div>
      <div id="auth-password-wrap">
        <input type="password" id="auth-password" placeholder="${t('auth.passwordPlaceholder')}" autocomplete="current-password" minlength="6">
      </div>
      <div id="auth-confirm-wrap" style="display:none;">
        <input type="password" id="auth-confirm-password" placeholder="${t('auth.confirmPassword')}" autocomplete="new-password" minlength="6">
      </div>
      <p id="auth-forgot-link" style="display:none;margin:0.5rem 0 0;text-align:right;">
        <button type="button" class="text-link-btn" onclick="openForgotPassword()">${t('auth.forgotPassword')}</button>
      </p>
      <p id="auth-back-login" style="display:none;margin:0.5rem 0 0;">
        <button type="button" class="text-link-btn" onclick="backToLogin()">${t('auth.backToLogin')}</button>
      </p>
      <p id="auth-error" class="auth-error"></p>
      <button id="auth-submit" class="modal-btn" type="submit">${t('auth.login')}</button>
    </form>
    <div id="auth-otp-actions" class="auth-otp-actions" style="display:none;">
      <button type="button" class="text-link-btn" onclick="backToRegistration()">${t('auth.otpBack')}</button>
      <button type="button" class="text-link-btn" id="auth-otp-resend" onclick="resendRegistrationCode()">${t('auth.otpResend')}</button>
    </div>
    <button onclick="closeAuthModal()" class="text-link-btn">${t('auth.cancel')}</button>
    <div class="account-lang-wrap" id="auth-lang-wrap"></div>
  </div>
</div>
`;
}

export function mountAuthModal(): void {
  mountTemplate('auth-modal', buildAuthTemplate());
  const wrap = document.getElementById('auth-lang-wrap');
  if (wrap) mountLangSwitcher(wrap);
}

export function remountAuthModal(): void {
  mountAuthModal();
}
